import React from "react";
import styled from "styled-components";

const Container = styled.div`
  font-size: 0.8em;
  margin: 20px;
  display: flex;
`;

const NoteMark = styled.div`
  flex: 0;
  margin-right: 6px;
`;

const NoteBody = styled.div`
  flex: 1;
`;

export default ({ children }) => {
  return (
    <Container>
      <NoteMark>*</NoteMark>
      <NoteBody>{children}</NoteBody>
    </Container>
  );
};
